import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

import { ThemeProvider } from 'styled-components';

import { dynamicTheme } from '../styles/theme';
import { IFCWithChildren } from '../interfaces/i-fc-with-children';
import { useCookies } from '../hooks/use-cookies';
import { ThemeOptionEnum } from '../enum/theme-option-enum';
import { cookies } from '../constants/cookies';

interface IThemeContextData {
  changeThemeOption: (option: ThemeOptionEnum) => void;
  changeBusinessPrimaryColor: (color?: string | null) => void;
  themeOption: ThemeOptionEnum;
}

const ThemeContext = createContext({} as IThemeContextData);

// @todo - alterar para nome genérico
const MonteiroEngenhariaThemeProvider: IFCWithChildren = ({ children }) => {
  const { getItem, setItem } = useCookies();
  const [themeOption, setThemeOption] = useState<ThemeOptionEnum>(
    (getItem(cookies.THEME_OPTION) as ThemeOptionEnum) || ThemeOptionEnum.light
  );
  const [businessPrimaryColor, setBusinessPrimaryColor] = useState<
    string | null
  >(null);

  const dynamic = useMemo(
    () => dynamicTheme(themeOption, businessPrimaryColor),
    [businessPrimaryColor, themeOption]
  );

  const changeThemeOption = useCallback(
    (option: ThemeOptionEnum) => {
      setThemeOption(option);
      setItem(cookies.THEME_OPTION, option);
    },
    [setItem]
  );

  const changeBusinessPrimaryColor = useCallback((color?: string | null) => {
    setBusinessPrimaryColor(color || null);
  }, []);

  return (
    <ThemeContext.Provider
      value={{
        themeOption,
        changeThemeOption,
        changeBusinessPrimaryColor,
      }}
    >
      <ThemeProvider theme={dynamic}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

const useCustomTheme = (): IThemeContextData => {
  return useContext(ThemeContext);
};

export { MonteiroEngenhariaThemeProvider, useCustomTheme };
